export const useIsConditionalContentDirty = () => {
  // TODO: create deep comparison between initial state and current state
  return true;
};
